import { createFileRoute } from '@tanstack/react-router'
import Page from '@/components/pages/inventory/settings/address/ph/page'

export const Route = createFileRoute('/_app/backend-settings/address/ph')({
  component: Page,
})
